import { render, staticRenderFns } from "./PlantationList.vue?vue&type=template&id=7fca1176&scoped=true"
import script from "./PlantationList.vue?vue&type=script&lang=js"
export * from "./PlantationList.vue?vue&type=script&lang=js"
import style0 from "./PlantationList.vue?vue&type=style&index=0&id=7fca1176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca1176",
  null
  
)

export default component.exports